exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-menu-item {\n\tborder-bottom: none !important;\n\theight: 35px !important;\n\tline-height: 35px !important;\n}\n.el-menu-item:focus, .el-menu-item:hover {\n\toutline: 0;\n\tbackground-color: rgba(0, 0, 0, 0.2) !important;\n}\n.el-menu-item.border-menu-item.is-active {\n\tborder-color: rgba(0, 0, 0, 0.1) !important;\n\tcolor: #fff;\n}\n", ""]);

// exports
